export const SCENE_SLIDES_MEDIA_SLOT = 'content';
export var SceneDataSlidesAssetType = /*#__PURE__*/function (SceneDataSlidesAssetType) {
  SceneDataSlidesAssetType["slideMobile"] = "slideMobile";
  SceneDataSlidesAssetType["slideDesktop"] = "slideDesktop";
  return SceneDataSlidesAssetType;
}(SceneDataSlidesAssetType || {});
export const SCENE_SLIDES_SLIDE_DURATION = 60; // seconds to calculate per slide